import { useModal } from "@homebound/beam";
import { useCallback } from "react";
import { AddItemsFromExistingPlanModal } from "src/routes/libraries/plan-package/takeoffs/components/AddItemsFromExistingPlanModal";
import {
  useTakeoffsManagerContext,
  useTakeoffsStore,
} from "src/routes/libraries/plan-package/takeoffs/TakeoffsManagerContext";

/** Opens the import modal (CSV upload, or a copy from another plan) for the Add menu and the group rows. */
export function useImportItems(): VoidFunction {
  const takeoffsStore = useTakeoffsManagerContext();
  const planPackageId = useTakeoffsStore((state) => state.planPackage.id);
  const versionId = useTakeoffsStore((state) => state.planPackage.version.id);
  const { openModal } = useModal();
  return useCallback(() => {
    const { saveTli, copyFromPlan } = takeoffsStore.getState();
    openModal({
      content: (
        <AddItemsFromExistingPlanModal
          planPackageId={planPackageId}
          planPackageVersionId={versionId}
          copyFromPlan={copyFromPlan}
          saveTli={saveTli}
        />
      ),
    });
  }, [openModal, takeoffsStore, planPackageId, versionId]);
}

/** Why adding a line is disabled until the side panel can add one. */
export const comingWithSidePanel = "Coming with the side panel";
